module cr.events {
    export class LiveLigneController {
        groupId:Number;

        static $inject = ['eventView','timingConfiguration', 'TrackingService', '$scope', '$stateParams'];

        constructor(private eventView, private timingConfiguration,  private trackingService, private $scope, private $stateParams) 
        {
        }        
    }


    export class LiveLigneGroupController 
    {
        groupId:Number;

        static $inject = ['eventView','timingConfiguration', 'TrackingService', '$scope', '$stateParams','group'];        

        constructor(private eventView, private timingConfiguration,  private trackingService, private $scope, private $stateParams,private group) 
        {
            
        }        
    }

}
